import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Partner(): ReactElement {
  return (
    <PageShell
      title="Partner"
      intro="Gemeinsam mehr erreichen – ob als Steuerberatung, Agentur oder Technologiepartner."
    >
      <PageSection title="Für Steuerberater">
        <p>
          Mit Saldify arbeiten Sie direkt mit den Buchhaltungsdaten Ihrer Mandanten –
          in Echtzeit und mit Ein-Klick-Export im DATEV-Format. Mehr dazu auf unserer
          Seite{' '}
          <a href="/steuerberater" className="text-primary-600 hover:underline">
            für Steuerberater
          </a>
          .
        </p>
      </PageSection>

      <PageSection title="Partner werden">
        <p>
          Sie sind Agentur, Berater oder bieten Dienstleistungen rund um
          Selbstständigkeit und Buchhaltung an? Wir freuen uns über Kooperationen.
          Schreiben Sie uns an{' '}
          <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
            info@saldify.de
          </a>
          .
        </p>
      </PageSection>
    </PageShell>
  );
}
